import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import ExpertAvatarComponent from './components/expert-avatar';

export const AVATAR_SIZE = 32;

export const CardTitle = styled(TitleMediumText)`
  a {
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  ${media.mediumDown`
    grid-template-columns: minmax(0, 1fr);
  `};
`;

export const Main = styled.main``;

export const Article = styled.article`
  padding: ${layout.measurements.spacingNormal};
  padding-top: 0;
`;

export const Item = styled.div`
  padding: 0 ${layout.measurements.spacingNormal};
`;

type SidebarProps = {
  viewport?: 'mobile' | 'desktop';
};

export const Sidebar = styled.aside<SidebarProps>(
  p => css`
    display: flex;
    flex-direction: column;
    padding: 0 ${layout.measurements.spacingSmall};
    flex-shrink: 0;

    ${media.mediumDown`
      padding: 0 ${layout.measurements.spacingNormal};

      ${p.viewport === 'desktop' &&
        css`
          display: none;
        `}
    `};

    ${media.largeUp`
      padding-right: ${layout.measurements.spacingNormal};

      ${p.viewport === 'mobile' &&
        css`
          display: none;
        `}
    `};
  `
);

export const Header = styled.header`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-flow: row;
  padding: ${layout.measurements.spacingNormal} 0;
  row-gap: ${layout.measurements.spacingSmall};
  height: max-content;

  h1 {
    margin: 0;
  }

  ${media.mediumDown`
    padding-bottom: ${layout.measurements.spacingSmall};
  `}
`;

type ContentProps = {
  order?: number;
};

export const Content = styled.div<ContentProps>(
  p => css`
    margin-top: ${layout.measurements.spacingNormal};
    display: grid;
    grid-auto-flow: row;
    row-gap: ${layout.measurements.spacingSmall};
    order: 2;

    &:not(:first-of-type) {
      margin-top: ${layout.measurements.spacingNormal};
    }

    a:not([class]) {
      color: ${p.theme.text.callToAction};

      &:hover {
        color: ${p.theme.text.callToActionHover};
        text-decoration: underline;
      }
    }

    ${media.mediumDown`
      order: ${p.order || 2};
    `};
  `
);

export const Info = styled.span`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  column-gap: ${layout.measurements.spacingSmall};
`;

export const Subtitle = styled(TitleMediumText)``;

export const Tagline = styled(Subtitle)`
  && {
    color: ${p => p.theme.text.secondary};
  }
`;

export const Title = styled(TitleMediumText)`
  &&,
  > * {
    font-size: ${layout.measurements.fontSizeMedium};
    font-weight: 700;
  }
`;

export const Media = styled.div`
  width: 100%;
`;

export const ContentType = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.secondary};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;

export const ExpertAvatar = styled(ExpertAvatarComponent)`
  grid-area: 1 / 1 / 4 / 2;
`;
